import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  if (amount >= 1000000000) {
    return `$${(amount / 1000000000).toFixed(1)}B`;
  } else if (amount >= 1000000) {
    return `$${(amount / 1000000).toFixed(1)}M`;
  } else if (amount >= 1000) {
    return `$${(amount / 1000).toFixed(1)}K`;
  }
  return `$${amount.toFixed(0)}`;
}

export function getMineralSymbol(commodity) {
  const symbols = {
    'Copper': 'Cu',
    'Lithium': 'Li',
    'Cobalt': 'Co',
    'Graphite': 'C',
    'Manganese': 'Mn',
    'Gold': 'Au',
    'Silver': 'Ag'
  };
  
  for (const [key, symbol] of Object.entries(symbols)) {
    if (commodity.includes(key)) return symbol;
  }
  return commodity.substring(0, 2).toUpperCase();
}

export function getMineralColor(commodity) {
  if (commodity.includes('Copper')) return '#B87333';
  if (commodity.includes('Lithium')) return '#C0C0C0';
  if (commodity.includes('Cobalt')) return '#0047AB';
  if (commodity.includes('Gold')) return '#FFD700';
  return '#71717A';
}

export function getStageColor(stage) {
  const colors = {
    'concept': 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    'feasibility': 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300',
    'development': 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300',
    'financial_close': 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300',
    'construction': 'bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-300',
    'operational': 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300'
  };
  return colors[stage] || colors.concept;
}

export function getStatusColor(status) {
  const colors = {
    'draft': 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    'submitted': 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300',
    'under_review': 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300',
    'approved': 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300',
    'active': 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300',
    'closed': 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300'
  };
  return colors[status] || colors.draft;
}
